import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SmallBarcode1100 = lazy(() => import('./pages/SmallBarcode1100'));

const barcodeRoutes: RouteObject[] = [
  {
    index: true,
    element: <SmallBarcode1100 />,
  },
  {
    path: 'small-1100',
    element: <SmallBarcode1100 />,
  },
];

export default barcodeRoutes;
